import { store } from "@/store/store";
import { VuexModule, Mutation, getModule, Module, Action } from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";
import { ventas_cabecera } from "@/shared/dtos/ventas_cabecera";
import { ventas_lineas } from "@/shared/dtos/ventas_lineas";

@Module({ namespaced: true, name: "ventasCabeceraModule", store, dynamic: true })
class ventasCabeceraModule extends VuexModule {
    public ventasList: ventas_cabecera[] = [];
    public venta: ventas_cabecera = new ventas_cabecera();
    public lineas: ventas_lineas[] = [];

    @Action({ commit: "onGetVentas" })
    public async getVentas() {
        return await ssmHttpService.get(API.ventas_cabecera);
    }

    @Action({ commit: "onGetVenta" })
    public async getVenta(id: number) {
        return await ssmHttpService.get(API.ventas_cabecera + id);
    }

    @Action({ commit: "onGetLineas" })
    public async getLineasByCabecera(id: number) {
        return await ssmHttpService.get(API.ventas_lineas + "byCabecera/" + id);
    }

    @Action
    public async guardarVenta(item: ventas_cabecera) {
        if (item.isNewItem()) {
            return await ssmHttpService.post(API.ventas_cabecera, item.toJson());
        } else {
            return await ssmHttpService.put(API.ventas_cabecera + item.id, item.toJson());
        }
    }

    @Action
    public async guardarLinea(linea: ventas_lineas) {
        if (linea.isNewItem()) {
            return await ssmHttpService.post(API.ventas_lineas, linea.toJson());
        } else {
            return await ssmHttpService.put(API.ventas_lineas + linea.id, linea.toJson());
        }
    }

    @Action
    public async eliminarLinea(id: number) {
        return await ssmHttpService.delete(API.ventas_lineas + id, {});
    }

    @Action
    public async eliminarVenta(id: number) {
        return await ssmHttpService.delete(API.ventas_cabecera + id, {});
    }

    @Mutation
    public onGetVentas(res: ventas_cabecera[]) {
        this.ventasList = res ? res.map((x) => new ventas_cabecera(x)) : [];
    }

    @Mutation
    public onGetVenta(res: ventas_cabecera) {
        this.venta = res ? new ventas_cabecera(res) : new ventas_cabecera();
    }

    @Mutation
    public onGetLineas(res: ventas_lineas[]) {
        this.lineas = res ? res.map((x) => new ventas_lineas(x)) : [];
    }
}

export default getModule(ventasCabeceraModule);
